import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import { getCompanyConfigOld } from '../../../../lib/api/company';
import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import EnhancedTab, {
  TabRow,
} from '../../../../lib/designSystem/TabSimulation';
import AccountingEntries from './components/AccountingEntries';
import MajorBookByIdentifierPage from './components/AuxiliaryBook';
import BankReconciliation from './components/BankReconciliation';
import DailyBook from './components/DailyBook';
import FinancialStatementBook from './components/FinancialStatementBook';
import MajorBook from './components/MajorBook';
import Periods from './components/Periods';
import PurchansesAndSales from './components/PurchansesAndSales';
import ReceiptFees from './components/ReceiptFee';
import TransactionBook from './components/TransactionsBook';
import { AccountingPeriodProvider } from './context/AccountingPeriodContext';

type AccountingTab = {
  label: string;
  component: React.ReactNode;
  path: string;
};
const Accounting: React.FC = () => {
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleNavigation = (index: number) => {
    navigate(`/finance/accounting/${companyTabs[index].path}`);
  };
  const [companyTabs, setCompanyTabs] = useState<AccountingTab[]>([]);
  const [startValue, setStartValue] = useState(0);
  const [loading, setLoading] = useState(true);

  const reportsTabs: AccountingTab[] = [
    {
      label: 'Compras/Ventas',
      component: <PurchansesAndSales />,
      path: 'purchasesAndSales',
    },
    {
      label: 'Honorarios',
      component: <ReceiptFees />,
      path: 'receiptFees',
    },
    {
      label: 'Transacciones',
      component: <TransactionBook />,
      path: 'transactionBook',
    },
    {
      label: 'Libro Diario',
      component: <DailyBook />,
      path: 'dailyBook',
    },
    {
      label: 'Libro mayor',
      component: <MajorBook />,
      path: 'majorBook',
    },
    {
      label: 'Libro auxiliar',
      component: <MajorBookByIdentifierPage />,
      path: 'auxiliaryBook',
    },
    {
      label: 'Balance',
      component: <FinancialStatementBook />,
      path: 'financialStatementBook',
    },
    {
      label: 'Asientos',
      component: <AccountingEntries />,
      path: 'accountingEntries',
    },
    {
      label: 'Períodos',
      component: <Periods />,
      path: 'periods',
    },
    {
      label: 'Conciliación Bancaria',
      component: <BankReconciliation />,
      path: 'bankReconciliation',
    },
  ];

  const setUpTabs = async () => {
    try {
      const transactionalEnableConfig = await getCompanyConfigOld(
        dispatch,
        'system_accounting_transactional_enabled',
      );
      const isTransactionBookEnabled = transactionalEnableConfig
        ? transactionalEnableConfig === '1'
        : true;

      const newReportTabs: AccountingTab[] = reportsTabs.filter((tab) => {
        if (tab.path === 'transactionBook') {
          return isTransactionBookEnabled;
        }
        return true;
      });

      let startValueDefault = 0;
      startValueDefault = newReportTabs.findIndex(
        (x: AccountingTab) => x.path === subPage,
      );

      if (subPage === 'transactionBook' && !isTransactionBookEnabled) {
        navigate(
          `/finance/accounting/${newReportTabs[0]?.path || 'purchasesAndSales'}`,
        );
        startValueDefault = 0;
      }

      setCompanyTabs(newReportTabs);
      setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    } catch (error) {
      console.error('Error fetching transaction book configuration:', error);
      const newReportTabs: AccountingTab[] = [...reportsTabs];
      let startValueDefault = 0;
      startValueDefault = newReportTabs.findIndex(
        (x: AccountingTab) => x.path === subPage,
      );
      setCompanyTabs(newReportTabs);
      setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    void setUpTabs();
  }, [subPage]);

  if (loading) return <CenteredCircularProgress type="layout" />;
  //Map companyTabs to TabRow[]
  const tabRows: TabRow[] = companyTabs.map((tab) => ({
    label: tab.label,
    component: tab.component as React.ReactElement,
  }));
  return (
    <AccountingPeriodProvider>
      <div>
        <div>
          <EnhancedTab
            startValue={startValue}
            tabs={tabRows}
            onTabChange={handleNavigation}
          />
        </div>
      </div>
    </AccountingPeriodProvider>
  );
};

export default Accounting;
